import { render } from "./AboutTitle.vue?vue&type=template&id=4e3b658f&scoped=true"
const script = {}

import "./AboutTitle.vue?vue&type=style&index=0&id=4e3b658f&scoped=true&lang=scss"

import exportComponent from "/Volumes/Quoicoubeh/Paraleclypse/website/paraleclypse/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4e3b658f"]])

export default __exports__